import { mapGetters } from 'vuex';
import digsMixin from '@/common/mixins/digsMixin.js';
import dmaZips from '@/common/models/configdata/data.dmaZipcodes.json';
import dppHotleadButton from '@/dpp/components/dpphotleadbutton/dpp-hotleadbutton.vue';
export default {
    name: 'propertySummaryTitle',
    inject: ['$eventBus', 'split'],
    mixins: [digsMixin],
    components: {
        dppHotleadButton,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getEstimatePriceRange', 'getEstimateInfo', 'getMortgagePerMonth']),
        lessThan12Months() {
            return this.dpp.soldDate && +new Date(this.dpp.soldDate) + 31557600000 > +new Date();
        },
        formattedLabelName() {
            if (this.dpp.rdcMoveinReady === false) {
                return 'Buildable house for sale';
            }
            let labelName = this.dpp.labelName.toLowerCase();
            //made the string jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec to capitalize
            labelName = labelName.replace(
                /(\bjan\b|\bfeb\b|\bmar\b|\bapr\b|\bmay\b|\bjun\b|\bjul\b|\baug\b|\bsep\b|\boct\b|\bnov\b|\bdec\b)/g,
                (match) => match.slice(0, 1).toUpperCase() + match.slice(1)
            );
            return this.dpp.propertyTypeDisplay + ' ' + labelName;
        },
        showSummaryLabels() {
            return !this.dpp.isRentals;
        },
        hidePricePreArea() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule && compliance[0].rule.indexOf('hidePricePreArea') >= 0;
        },

        showVeteransDrawLink() {
            if (dmaZips.includes(this.dpp.geo.zipcode) && !['LAND', 'MOBILE'].includes(this.dpp.propertyType)) {
                return true;
            }
            return false;
        },
        openVeteransHotlead({ leadType }) {
            const deviceType = this.glb.isMobile ? '_Mobile' : '_Desktop';
            const hotleadType = leadType ? leadType + deviceType : 'veterandropdrawerlead';
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Meet a Veterans Real Estate Agent',
                    hotleadType: hotleadType,
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                    showComment: false,
                    isVeteranDrawer: true,
                    ojoFormConfigs: {
                        showCtaLinks: true,
                        showOJOagentInfo: true,
                        showDisclaimer: false,
                        commnetLabel: 'Message',
                    },
                },
            });
        },
        getPreApprovedObj() {
            var betterLink = ['MA', 'HI', 'NH', 'NV'].indexOf(this.dpp.geo.state) === -1;
            var isLandMobile = this.dpp.houseRealStatus === 'ACTIVE' && this.dpp.price <= 100000 && ['LAND', 'MOBILE'].includes(this.dpp.propertyType);
            const obj = {
                cta: this.dpp.isActive ? 'Get pre-approved' : this.molang('dpp.propertyDetails.getLowerPayment'),
                utmcta: this.dpp.isActive ? 'apply' : 'refinance',
                url: this.dpp.isActive ? (isLandMobile ? 'prequalifylandmobile' : betterLink ? 'betterpreapproved' : 'preapprove') : 'refinance',
            };
            return obj;
        },
        newSoldPublicRecordCta() {
            return this.getSplit('movoto-new-sold-pr-cta-CW-3566');
        },
        ctaRequestTourSubtext() {
            const splitValue = this.glb.splits['movoto-dpp-cta-button-CW-4438'] ?? null;
            switch (splitValue) {
                case 'on1':
                    return 'See it in person';
                case 'on2':
                    return 'No obligation';
                case 'on3':
                    return 'Always free';
                case 'on4':
                    return 'Pick your time';
                case 'on5':
                    return 'See before it’s gone';
                case 'on6':
                    return 'Tour with local expert';
                case 'on7':
                    return 'No spam, no pressure';
                case 'on8':
                    return 'Experience in person';
                default:
                    return null;
            }
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        showTransDialog() {
            this.$eventBus.$emit('eventbus-pop-trans');
        },
        openDisclaimer() {
            if (this.getEstimateInfo && this.getEstimateInfo.type === 'avm') {
                this.$eventBus.$emit('dialog-center', { name: 'dppPopAvm', opt: {}, trigger: this.$options.name });
            } else {
                this.$eventBus.$emit('dialog-center', { name: 'dppPopEst', opt: {}, trigger: this.$options.name });
            }
        },
        async showForm(applyObj) {
            const treatment = await this.split.fetchTreatments(['movoto-cpc-apply-cw-9238'], {
                attributes: {
                    movoto_geo_state: this.dpp.geo.state,
                    movoto_geo_zipcode: this.dpp.geo.zipcode,
                    movoto_listing_price: this.dpp.price,
                    movoto_listing_type: this.dpp.propertyType,
                    movoto_listing_status: this.dpp.houseRealStatus,
                },
            });

            switch (treatment['movoto-cpc-apply-cw-9238']) {
                //FIND LENDER SUB 100 MRC POP UP
                case 'on12':
                    this.$eventBus.$emit('dialog-center', {
                        name: 'mrcMortgageRates',
                        trigger: this.$options.name,
                        opt: {
                            showNormalMrc: true,
                            utm_campaign: 'getpreapprovedATF_sub100',
                            cta: applyObj.cta,
                            ga: 'partner_mortgage_listings_session_sub100k',
                        },
                    });
                    return;
                case 'on13':
                    this.$eventBus.$emit('dialog-center', {
                        name: 'mrcMortgageRates',
                        trigger: this.$options.name,
                        opt: {
                            showNormalMrc: true,
                            utm_campaign: 'Get Preapproved ATF_inactive',
                            cta: applyObj.cta,
                            ga: 'partner_mortgage_listings_session',
                            desc: 'getpreapproved',
                        },
                    });
                    return;
                case 'on9':
                    this.$eventBus.$emit('dialog-center', {
                        name: 'mrcMortgageRates',
                        trigger: this.$options.name,
                        opt: {
                            showNormalMrc: true,
                            utm_campaign: 'getpreapprovedATF',
                            cta: applyObj.cta,
                            ga: 'partner_mortgage_listings_session',
                            desc: 'getpreapproved',
                        },
                    });
                    return;
            }
            if (this.getSplit('movoto-cpc-apply-cw-9238', 'on15')) {
                applyObj.utmcta = 'apply';
            }
            this.show3rdPartyFormFromDppTitle(applyObj.utmcta, applyObj.url, applyObj.cta);
        },
        show3rdPartyFormFromDppTitle(utmcta, url, cta, isAppendUtmCta = false) {
            var pid;
            if (this.dpp.isActive && this.dpp.price <= 100000) {
                if (this.dpp.propertyType === 'MOBILE') {
                    pid = 'movoto_mobile';
                } else if (this.dpp.propertyType === 'LAND') {
                    pid = 'movoto_land';
                }
            }
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                pid: pid,
                id: utmcta,
                url: url,
                zipcode: this.dpp.geo.zipcode,
                price: this.dpp.price,
                propertyType: this.dpp.propertyType,
                houseRealStatus: this.dpp.houseRealStatus,
                trigger: this.$options.name,
                cta: cta,
                imageUrl: this.dpp.tnImgPath,
                listingUrl: (this.dpp.path && `${this.glb.appUrl}${this.dpp.path}`) || '',
                isAppendUtmCta: isAppendUtmCta,
            });
        },
        show3way() {
            if (this.getSplit('movoto-mortgage-CW-4337', 'on14')) {
                this.show3rdPartyFormFromDppTitle('fha', '', 'Check eligibility');
                return;
            }
            if (this.getSplit('movoto-calcpayment-cw-12068', 'on14')) {
                this.show3rdPartyFormFromDppTitle('fha', '', 'Do You Qualify for Low Money Down? Check ' + (this.dpp.isNewDpp ? '' : 'FHA ') + 'Eligibility');
                return;
            }
            const mrcUrl = this.glb.appUrl + 'mortgage/mrc' + '?title=FHA&fallback=FHA_LP';
            window.open(mrcUrl, '_blank');
            this.$eventBus.$emit('ga', {
                ec: 'partner_mortgage_FHA_session',
                en: 'Long Form',
                el: 'MRC',
                props: { link_name: 'Do You Qualify for Low Money Down? Check ' + (this.dpp.isNewDpp ? '' : 'FHA ') + 'Eligibility - LP' },
            });
            return;
        },
        popContactUs() {
            this.$eventBus.$emit('dialog-open-contactus', { enquiryType: 5 });
        },
    },
    data() {
        return {
            hideEstMonthCost: false,
        };
    },
    mounted() {
        this.hideEstMonthCost = this.getComplianceMethod()().some((item) => item.rule.indexOf('hideEstMonthCost') >= 0);
    },
};
